<template>
  <div>
    <b-modal
      ref="errorModal"
      header-bg-variant="cosmos"
      header-class="text-white"
    >
      <template #modal-header>
        <h3>
          <i class="ifr if-cancel text-danger mr-3"></i
          >{{ $t("scan.error.headline") }}
        </h3>
      </template>
      <b-row>
        <b-col cols="12">
          <p>
            {{ error_text }}
          </p>
        </b-col>
      </b-row>
      <template #modal-footer>
        <b-row>
          <b-col cols="12" class="text-center">
            <button class="btn btn-secondary" @click="closeErrorModal">
              {{ $t("actions.ok") }}
            </button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import api from "@a/index";
  import formularKeyDecoder from "@/services/formulars/formularKeyDecoder";

  export default {
    name: "DigitalFormular",
    props: {
      token: {
        type: String,
        required: true,
      },
    },
    async created() {
      try {
        let response = await api.publicToken.getInfo(this.token);

        if (response.data.valid) {
          let page = formularKeyDecoder.getFormularPage(response.data.formular);

          if (page) {
            this.$router.replace({
              name: page,
              params: { token: response.data.token },
            });
          } else {
            this.error_text = this.$t("scan.error.no_assignment");
            this.$refs.errorModal.show();
          }
        } else {
          this.error_text = this.$t("scan.error.token_invalid");
          this.$refs.errorModal.show();
        }
      } catch (e) {
        this.error_text = this.$t("scan.error.token_invalid");
        this.$refs.errorModal.show();
      }
    },
    methods: {
      closeErrorModal() {
        this.$refs.errorModal.hide();
        this.error_text = null;
      },
    },
  };
</script>

<style>
</style>
